import gql from 'graphql-tag';
export default gql`
  query subGroups($industryId: String!, $subDivisionId: String!) {
    subGroups(industryId: $industryId, subDivisionId: $subDivisionId) {
      docId
      name
    }
  }
`;
